//@ts-nocheck
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router";
import { getSearchVarsArray } from "../../routes/router";
import RouteCls from "../../lib/route/route";

export function GLink(props) {
  const { to, ...other } = props;

  const [newTo, setNewTo] = useState("");
  const [action, setAction] = useState({ component: "", path: "" });

  useEffect(() => {
    let component;
    let componentPath;
    if (to && to.includes("?app") && !to.includes("/ARC")) {
      const newTo = convertToArcPath(to);
      setNewTo(newTo);
    } else if (to && to.includes("?CID_READY") && to.includes("VERSION")) {
      const newRouter = RouteCls.removeQueryParam(
          window.location.href,
          "CID_READY"
      );
      const [, search] = newRouter.split("?");

      const newUrl = search ? `/?${search}` : "/";
      setNewTo(newUrl);
    } else if (to && to.includes("?app") && to.includes("/ARC")) {
      const [, router] = to.split("/ARC/");

      if (router) {
        const [action, path] = router.split("??");
        if (action) {
          const [c] = action.split("/");
          component = c;
        }
        if (path) {
          componentPath = path.replace("router=", "");
        }
        const p = convertToArcPath(componentPath);
        setAction({ component, path: p });
      }
    } else {
      setNewTo(to);
    }
    
  }, [to]);

  const convertToArcPath = (path) => {
    const vars = getSearchVarsArray(path);
    let newTo = `/ARC`;
    for (let i = 0; i < vars.length; i++) {
      newTo += `/${vars[i]}`;
    }
    return newTo;
  };

  return (
    <React.Fragment>
      {newTo ? <Link to={newTo} {...other} /> : null}
      {action?.component === "storyLayout"}
    </React.Fragment>
  );
}

export function Redirect({ to }) {
  const navigate = useNavigate();

  useEffect(() => {
    return navigate(to);
    
  }, [to]);

  return <></>;
}
